





















import { Component, Prop, Vue } from "vue-property-decorator";

import { Table as CatalogTable } from "@/components/organisms/Table";
import { ITableRow } from "@/components/organisms/Table/interfaces";
import { View } from "@/components/organisms/Table/enums";
import { defaultHeaders } from "@/components/pages/CatalogPage/blocks/ProductsList/mocks";

import { IProduct } from "@/services/interfaces";
import { calcMarginPrice } from "@/services/utils";

import { catalogModule, pricesModule } from "@/plugins/store-accessors";
import { SortDirections } from "@/store/catalog/enums";

@Component({
  name: "related-products",
  components: {
    CatalogTable,
  },
})
export default class RelatedProducts extends Vue {
  tableViewType: View = View.table;
  tableHeaders = defaultHeaders;
  sortBy: string | null = null;
  sortDirection: string | null = null;

  @Prop({ type: Array, default: () => [] })
  readonly products!: IProduct[];

  get currentDataPrice() {
    return pricesModule.getCurrentData;
  }

  get getQuantity() {
    return catalogModule.getQuantity;
  }

  get productWithTypePrice() {
    const currentDataPrice = this.currentDataPrice;
    if (currentDataPrice) {
      return this.products.map((el: IProduct) => ({
        ...el,
        price: calcMarginPrice(
          Number(el.price),
          currentDataPrice.margin,
          currentDataPrice.rounding,
        ),
        promo_price: !!el.promo_price
          ? calcMarginPrice(
              Number(el.promo_price),
              currentDataPrice.margin,
              currentDataPrice.rounding,
            )
          : undefined,
      }));
    }
    return this.products;
  }

  get rows(): ITableRow[] {
    const rows = this.productWithTypePrice.map(
      (el: IProduct, index: number) => ({ ...el, type: "product", index }),
    ) as ITableRow[];

    if (!this.sortBy) {
      return rows;
    }

    const direction = this.sortDirection === SortDirections.DESC ? -1 : 1;
    return rows.slice().sort((a: any, b: any) => {
      const aVal = a[this.sortBy as string];
      const bVal = b[this.sortBy as string];

      if (aVal === null || aVal === undefined) return 1;
      if (bVal === null || bVal === undefined) return -1;
      if (typeof aVal === "number" && typeof bVal === "number") {
        return (aVal - bVal) * direction;
      }
      return String(aVal).localeCompare(String(bVal), "ru") * direction;
    });
  }

  setType(view: View) {
    this.tableViewType = view;
    localStorage.setItem("relatedViewType", view);
  }

  changeQuantity(pl: { id: number; val: number }) {
    return catalogModule.changeQuantity(pl);
  }

  changeSort(name: string) {
    if (this.sortBy === name) {
      switch (this.sortDirection) {
        case SortDirections.ASC:
          this.sortDirection = SortDirections.DESC;
          break;
        case SortDirections.DESC:
          this.sortBy = null;
          this.sortDirection = null;
          break;
        default:
          this.sortDirection = SortDirections.ASC;
          break;
      }
    } else {
      this.sortBy = name;
      this.sortDirection = SortDirections.ASC;
    }
  }

  mounted() {
    const type = localStorage.getItem("relatedViewType") as View;
    if (type) {
      this.tableViewType = type;
    }
  }
}
